"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var ReplenishmentPromoManagementUpdateResult =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ReplenishmentPromoManagementUpdateResult, _DomainObject_1$Domai);

  function ReplenishmentPromoManagementUpdateResult(updatedRows, errors) {
    var _this;

    _classCallCheck(this, ReplenishmentPromoManagementUpdateResult);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReplenishmentPromoManagementUpdateResult).call(this));
    _this.updatedRows = updatedRows;
    _this.errors = errors;
    return _this;
  }

  return ReplenishmentPromoManagementUpdateResult;
}(DomainObject_1.DomainObject);

exports.ReplenishmentPromoManagementUpdateResult = ReplenishmentPromoManagementUpdateResult;